import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let CollapsibleRowComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.usedWidth = "100%";
    this.hiddenIndexes = [];
    this.skipResize = true;
    this.isChecking = false;
    this.resizeObserver = null;
  }
  mounted() {
    this.resizeObserver = new ResizeObserver(() => {
      this.checkVisibilityChange();
    });
    this.$nextTick().then(() => {
      const host = this.$el.getRootNode().host;
      this.resizeObserver.observe(host.parentElement || host);
      this.checkVisibilityChange();
    });
  }
  destroyed() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
  onItemsChange() {
    this.checkVisibilityChange();
  }
  itemRefs() {
    const refs = this.$refs.item;
    if (!refs || !Array.isArray(refs) || !(refs[0] instanceof Element)) {
      return [];
    }
    return refs;
  }
  checkVisibilityChange(emitEmptyList = true, allowRecursion = true) {
    return __async(this, null, function* () {
      if (this.isChecking) {
        return;
      }
      const oldHiddenIndexes = this.hiddenIndexes;
      const itemRefs = this.itemRefs();
      if (itemRefs.length === 0) {
        this.emitHidden([]);
        return;
      }
      this.isChecking = true;
      if (emitEmptyList) {
        this.emitHidden([]);
      }
      yield this.resetHiddenComponents();
      const { width: contWidth } = this.$el.getRootNode().host.getBoundingClientRect();
      let index = 0;
      let usedWidth = 0;
      const hiddenItems = [];
      const hiddenIndexes = [];
      for (const item of itemRefs) {
        const { width } = item.getBoundingClientRect();
        const currentWidth = width + usedWidth;
        if (currentWidth > contWidth) {
          hiddenItems.push(this.items[index]);
          hiddenIndexes.push(index);
        } else {
          usedWidth = currentWidth;
        }
        index++;
      }
      this.emitHidden(hiddenItems);
      this.usedWidth = usedWidth + "px";
      this.hiddenIndexes = hiddenIndexes;
      if (hiddenIndexes.length !== oldHiddenIndexes.length || !hiddenIndexes.every((item) => oldHiddenIndexes.includes(item))) {
        yield this.$nextTick();
        this.isChecking = false;
        if (allowRecursion) {
          this.checkVisibilityChange(hiddenIndexes.length === 0, false);
        }
        return;
      }
      this.isChecking = false;
    });
  }
  resetHiddenComponents() {
    return __async(this, null, function* () {
      this.usedWidth = "100%";
      this.hiddenIndexes = [];
      yield this.$nextTick();
    });
  }
  emitHidden(items) {
    return items;
  }
  onItemClick(slug) {
    return slug;
  }
};
__decorateClass([
  Prop(Array)
], CollapsibleRowComponent.prototype, "items", 2);
__decorateClass([
  Prop(String)
], CollapsibleRowComponent.prototype, "activeItem", 2);
__decorateClass([
  Prop(Boolean)
], CollapsibleRowComponent.prototype, "left", 2);
__decorateClass([
  Prop(Boolean)
], CollapsibleRowComponent.prototype, "right", 2);
__decorateClass([
  Watch("items", { immediate: true })
], CollapsibleRowComponent.prototype, "onItemsChange", 1);
__decorateClass([
  Emit("hidden")
], CollapsibleRowComponent.prototype, "emitHidden", 1);
__decorateClass([
  Emit("item-click")
], CollapsibleRowComponent.prototype, "onItemClick", 1);
CollapsibleRowComponent = __decorateClass([
  Component({
    name: "ui-collapsible-row"
  })
], CollapsibleRowComponent);

export default CollapsibleRowComponent;
